import React from "react";
import AdminPanel from "../shared/AdminPanel";
import panelStyles from "../styles/Panel.module.css";
import styles from "../styles/ConfigEditors.module.css";

function PhotosessionSectionBody({ state, actions }) {
  const {
    photosessionConfig,
    photosessionLoading,
    photosessionSaving,
    photosessionDirty,
    photosessionUploadingIndex,
    styles: photoStyles
  } = state;

  return (
    <>
      <div className={styles.rowThree}>
        <input
          type="number"
          className={panelStyles.input}
          value={Number(photosessionConfig?.pageSize || 5)}
          onChange={(event) => actions.updateConfig({ pageSize: Number(event.target.value) })}
          placeholder="Изображений на странице"
        />
        <input
          type="number"
          className={panelStyles.input}
          value={Number(photosessionConfig?.tokenCost || 8000)}
          onChange={(event) => actions.updateConfig({ tokenCost: Number(event.target.value) })}
          placeholder="Стоимость в токенах"
        />
        <input
          type="number"
          className={panelStyles.input}
          value={Number(photosessionConfig?.oneTimeProductId || 9)}
          onChange={(event) => actions.updateConfig({ oneTimeProductId: Number(event.target.value) })}
          placeholder="ID продукта"
        />
      </div>

      <div className={styles.row}>
        <button
          type="button"
          className={panelStyles.buttonSecondary}
          onClick={actions.reload}
          disabled={photosessionLoading}
        >
          {photosessionLoading ? "Обновляем..." : "Перезагрузить"}
        </button>
        <button
          type="button"
          className={panelStyles.button}
          onClick={actions.save}
          disabled={!photosessionDirty || photosessionSaving}
        >
          {photosessionSaving ? "Сохраняем..." : "Сохранить"}
        </button>
      </div>

      <button type="button" className={panelStyles.buttonSecondary} onClick={actions.addStyle}>
        Добавить стиль
      </button>

      {photoStyles.length > 0 ? (
        <div className={styles.cardList}>
          {photoStyles.map((item, index) => (
            <div key={item.id || `style-${index}`} className={styles.card}>
              <div className={styles.cardHeader}>
                <strong>{item.title || `Стиль #${index + 1}`}</strong>
                <div className={styles.cardActions}>
                  <button
                    type="button"
                    className={panelStyles.buttonSecondary}
                    onClick={() => actions.moveStyle(index, "up")}
                    disabled={index === 0}
                  >
                    Вверх
                  </button>
                  <button
                    type="button"
                    className={panelStyles.buttonSecondary}
                    onClick={() => actions.moveStyle(index, "down")}
                    disabled={index === photoStyles.length - 1}
                  >
                    Вниз
                  </button>
                  <button
                    type="button"
                    className={panelStyles.buttonSecondary}
                    onClick={() => actions.removeStyle(index)}
                  >
                    Удалить
                  </button>
                </div>
              </div>

              <div className={styles.rowThree}>
                <input
                  type="text"
                  className={panelStyles.input}
                  value={item.emoji || "✨"}
                  placeholder="Эмодзи"
                  onChange={(event) => actions.updateStyle(index, { emoji: event.target.value })}
                />
                <input
                  type="text"
                  className={panelStyles.input}
                  value={item.title || ""}
                  placeholder="Название"
                  onChange={(event) => actions.updateStyle(index, { title: event.target.value })}
                />
                <select
                  className={panelStyles.select}
                  value={item.active === false ? "0" : "1"}
                  onChange={(event) => actions.updateStyle(index, { active: event.target.value === "1" })}
                >
                  <option value="1">Активен</option>
                  <option value="0">Скрыт</option>
                </select>
              </div>

              <div className={styles.row}>
                <input
                  type="number"
                  className={panelStyles.input}
                  value={item.likes ?? 0}
                  placeholder="Лайки"
                  onChange={(event) => actions.updateStyle(index, { likes: Number(event.target.value) })}
                />
                <input
                  type="number"
                  className={panelStyles.input}
                  value={item.dislikes ?? 0}
                  placeholder="Дизлайки"
                  onChange={(event) => actions.updateStyle(index, { dislikes: Number(event.target.value) })}
                />
              </div>

              <textarea
                rows={5}
                className={panelStyles.textarea}
                value={item.prompt || ""}
                placeholder="Промпт"
                onChange={(event) => actions.updateStyle(index, { prompt: event.target.value })}
              />

              <div className={styles.row}>
                <input
                  type="text"
                  className={panelStyles.input}
                  value={item.previewAttachment || ""}
                  placeholder="вложение photo-..."
                  onChange={(event) => actions.updateStyle(index, { previewAttachment: event.target.value })}
                />
                <input
                  type="file"
                  accept="image/*"
                  onChange={(event) => {
                    const file = event.target.files && event.target.files[0] ? event.target.files[0] : null;
                    if (file) {
                      actions.uploadPreview(index, file);
                    }
                  }}
                />
              </div>

              <div className={panelStyles.note}>
                {photosessionUploadingIndex === index
                  ? "Загружаем..."
                  : item.previewAttachment || "Превью еще не загружено"}
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className={styles.empty}>Стили еще не настроены.</div>
      )}
    </>
  );
}

export function PhotosessionSection({ mode = "panel", isOpen = true, onToggle, state, actions }) {
  if (mode === "page") {
    return <PhotosessionSectionBody state={state} actions={actions} />;
  }

  return (
    <AdminPanel id="photosession" title="Фотосессия" isOpen={isOpen} onToggle={onToggle}>
      <PhotosessionSectionBody state={state} actions={actions} />
    </AdminPanel>
  );
}

export default PhotosessionSection;
